import styled from 'styled-components';

export const MyTripsActionMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        background-color: ${props.theme.colors.white.base};
        box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
        border-radius: 0.6rem;
        align-self: flex-start;
        margin-bottom: ${props.theme.spacing.large.l15};
    `
);

export const MyTripsActionInnerWrap = styled.div(
    props => `
        display: flex;
        flex-direction: column;
    `
);

export const TripActionWrap = styled.div(
    props => `
        display: flex
        flex-direction: column;
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l25} 0;
        border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
    `
);

export const TripActionHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        padding-bottom: ${props.theme.spacing.large.l20}
    `
);

export const TripActionInnerWrap = styled.div(
    props => `
        display: flex;
        align-items: center;
        padding-bottom: ${props.theme.spacing.large.l20}
    `
);

export const TripActionIconWrap = styled.div(
    props => `
        width:2.4rem;
        height: 2.4rem;
    `
);


export const TripActionText = styled.a(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        padding-left: ${props.theme.spacing.large.l15};
        text-decoration: none;
        &:hover{
          color: ${props.theme.colors.blue.base};
        }
    `
);